<template>
    <div :class="{'app-main': true, 'w100': $route.path==='/clientPage/detail' || $route.path==='/packagePreview' || $route.path==='/clientAdmin/engagementInfo'}">
        <keep-alive>
            <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: "AppMain",
    computed: {
        key() {
            return this.$route.fullPath
        }
    }
}
</script>

<style scoped lang="less">
    .app-main {
      padding-top: 20px;
      padding-bottom: 20px;
      max-width: 90%;
      margin: 0 auto;
      &.w100 {
        padding-top: 0;
        max-width: 100%;
      }
    }

@media (max-width: 768px) {
  .app-main {
    max-width: 100%;
    padding: 24px 12px 24px;
    box-sizing: border-box;
    &.w100 {
      padding-left: 0;
      padding-right: 0;
      padding-top: 12px;
    }
  }
}
</style>
